module.exports = __webpack_public_path__ + "static/img/gaozhongshuxue5.2b20da05.jpg";